Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    buttonMotionDuration: "100ms",
    buttonMotionFunction: "ease",
    buttonBackgroundColorPrimaryDefault: tokens.themeActionPrimaryDefault,
    buttonBackgroundColorPrimaryHover: tokens.themeActionPrimaryHover,
    buttonBackgroundColorPrimaryPressed: tokens.themeActionPrimaryPressed,
    buttonBackgroundColorPrimaryDisabled: tokens.themeActionPrimaryDisabledSubdued,
    buttonBackgroundColorSecondaryDefault: tokens.themeActionSecondaryDefault,
    buttonBackgroundColorSecondaryHover: tokens.themeActionSecondaryHover,
    buttonBackgroundColorSecondaryPressed: tokens.themeActionSecondaryPressed,
    buttonBackgroundColorSecondaryDisabled: tokens.themeActionSecondaryDisabled,
    buttonBackgroundColorTertiaryDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorTertiaryHover: tokens.themeActionPrimaryHover,
    buttonBackgroundColorTertiaryPressed: tokens.themeActionPrimaryPressed,
    buttonBackgroundColorLinkDefault: tokens.themeActionNeutralDefault,
    buttonBackgroundColorLinkHover: tokens.themeActionNeutralHover,
    buttonBackgroundColorLinkPressed: tokens.themeActionNeutralPressed,
    buttonBackgroundColorIconDefault: tokens.themeActionNeutralDefault,
    buttonBackgroundColorIconHover: tokens.themeActionNeutralHover,
    buttonBackgroundColorIconPressed: tokens.themeActionNeutralPressed,
    buttonForegroundColorPrimaryDefault: tokens.themeInkInverse,
    buttonForegroundColorPrimaryDisabled: tokens.themeActionPrimaryDisabled,
    buttonForegroundColorSecondaryDefault: tokens.themeInkDefault,
    buttonForegroundColorSecondaryDisabled: tokens.themeInkDisabled,
    buttonForegroundColorTertiaryDefault: tokens.themeActionPrimaryDefault,
    buttonForegroundColorTertiaryHover: tokens.themeInkInverse,
    buttonForegroundColorTertiaryFocus: tokens.themeInkInverse,
    buttonForegroundColorTertiaryPressed: tokens.themeInkInverse,
    buttonForegroundColorTertiaryDisabled: tokens.themeActionPrimaryDisabled,
    buttonForegroundColorLinkDefault: tokens.themeActionPrimaryDefault,
    buttonForegroundColorLinkHover: tokens.themeActionPrimaryHover,
    buttonForegroundColorLinkPressed: tokens.themeActionPrimaryPressed,
    buttonForegroundColorLinkDisabled: tokens.themeActionPrimaryDisabled,
    buttonForegroundColorIconDefault: tokens.themeInkDefault,
    buttonForegroundColorIconDisabled: tokens.themeInkDisabled,
    buttonFontSizeSmall: 14,
    buttonFontSizeMedium: 16,
    buttonFontSizeLarge: 18,
    buttonFontSizeXlarge: 28,
    buttonFontWeightSmall: 400,
    buttonFontWeightMedium: 400,
    buttonFontWeightLarge: 400,
    buttonFontWeightXlarge: 400,
    buttonLineHeightSmall: "20px",
    buttonLineHeightMedium: "24px",
    buttonLineHeightLarge: "24px",
    buttonLineHeightXlarge: "36px",
    buttonBorderWidth: 2,
    buttonBorderRadius: 4,
    buttonBorderColorTertiaryDefault: tokens.themeActionPrimaryDefault,
    buttonBorderColorTertiaryHover: tokens.themeActionPrimaryHover,
    buttonBorderColorTertiaryPressed: tokens.themeActionPrimaryPressed,
    buttonBorderColorTertiaryDisabled: tokens.themeActionPrimaryDisabled,
    buttonSpacingInsetHorizontalSmall: 10,
    buttonSpacingInsetHorizontalMedium: 16,
    buttonSpacingInsetHorizontalLarge: 16,
    buttonSpacingInsetHorizontalXlarge: 24,
    buttonHeightSmall: 32,
    buttonHeightMedium: 40,
    buttonHeightLarge: 48,
    buttonHeightXlarge: 64,
    buttonFocusOutlineOffset: 4
  }
};